var render, staticRenderFns
import script from "./BaseLayoutCustom.vue?vue&type=script&lang=js"
export * from "./BaseLayoutCustom.vue?vue&type=script&lang=js"
import style0 from "./BaseLayoutCustom.vue?vue&type=style&index=0&id=1dcf419d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcf419d",
  null
  
)

export default component.exports